const ZDANIA39 = [
  {
    name: "[6 klasa] Ang Styczeń 2024",
    lang: 'en',
    zdania: [
      {
        pl: "Czy mogę prosić o jeszcze trochę chleba?",
        de: "Can I have some more bread, please?",
      },
      {
        pl: "Czy możemy prosić o kolejną butelkę wina?",
        de: "Can I have another bottle of wine, please?",
      },
      {
        pl: "Czy możemy prosić o trochę wody?",
        de: "Can I have some water, please?",
      },
      {
        pl: "Czy chcieliby Państwo kawę lub deser?",
        de: "Would you like some coffee or dessert?",
      },
      {
        pl: "Czy możemy prosić o rachunek, proszę?",
        de: "Could we have the bill, please?",
      },
      {
        pl: "Czy mogę zapłacić kartą?",
        de: "Can I pay by card?",
      },
      {
        pl: "Czy akceptują Państwo karty kredytowe?",
        de: "Do you accept credit cards?",
      },
      {
        pl: "Czy wliczona jest obsługa?",
        de: "Is service included?",
      },
      {
        pl: "Czy możemy zapłacić osobno?",
        de: "Can split the bill?",
      },
      {
        pl: "Proszę oczekiwać na stolik",
        de: "Please wait to be seated",
      },
      {
        pl: "Rezerwacja",
        de: "Reservation",
      },
      {
        pl: "Obsługa (nie) wliczona",
        de: "Service (not) included",
      },
      {
        pl: "Co to za danie?",
        de: "What's this dish?",
      },
      {
        pl: "Jestem na diecie",
        de: "I'm on a diet",
      },
      {
        pl: "Mam alergię na laktozę",
        de: "I'm allergic to lactose",
      },
      {
        pl: "przystawka",
        de: "starter/appetizer",
      },
      {
        pl: "danie główne",
        de: "main course",
      },
      {
        pl: "Jak chcesz mieć steki?",
        de: "How would you like your steak cooked?",
      },
      {
        pl: "Dobrze wysmażony",
        de: "Well done",
      },
      {
        pl: "Średnio wysmażony",
        de: "Medium",
      },
      {
        pl: "Słabo wysmażony",
        de: "Rare",
      },
      {
        pl: "Czy chcieliby Państwo spróbować wina?",
        de: "Would you like to try the wine?",
      },
      {
        pl: "Na ile osób?",
        de: "For how many people?",
      },
      {
        pl: "Mam rezerwację.",
        de: "I have a reservation.",
      },
      {
        pl: "Czy mają Państwo rezerwację?",
        de: "Do you have a reservation?",
      },
      {
        pl: "Czy mogę zobaczyć menu, proszę?",
        de: "May I see the menu, please?",
      },
      {
        pl: "Czy mogę zobaczyć kartę win, proszę?",
        de: "May I see the wine list, please?",
      },
      {
        pl: "Czy mogę zobaczyć kartę deserów, proszę?",
        de: "Could I have the dessert menu please?",
      },
      {
        pl: "Co jest zupa dnia?",
        de: "What's the soup of the day?",
      },
      {
        pl: "Co polecasz?",
        de: "What do you recommend?",
      },
      {
        pl: "Co dzisiaj jest w promocji?",
        de: "What's on special today?",
      },
      {
        pl: "Czy mogę prosić o dolewkę, proszę?",
        de: "Can I have a refill, please?",
      },
      {
        pl: "Czy mogę prosić o jeszcze jeden kiepsziek wina, proszę?",
        de: "Can I have another glass of wine, please?",
      },
      {
        pl: "Jestem gotowy do zamówienia",
        de: "I'm ready to order",
      },
      {
        pl: "Co chciałbyś/chciałabyś do picia?",
        de: "What would you like to drink?",
      },
      {
        pl: "Co chciałbyś/chciałabyś zamówić?",
        de: "What would you like to order?",
      },
      {
        pl: "owoce morza",
        de: "seafood",
      },
      {
        pl: "saładka",
        de: "salad",
      },
      {
        pl: "gotoowany",
        de: "boiled",
      },
      {
        pl: "smażony",
        de: "fried",
      },
      {
        pl: "grillowany",
        de: "grilled",
      },
      {
        pl: "pieczony",
        de: "roasted",
      },
      {
        pl: "posiekany",
        de: "chopped",
      },
      {
        pl: "Czy mają Państwo wolne stoliki?",
        de: "Do you have any tables available?",
      },
      {
        pl: "Stolik dla dwóch osób, proszę",
        de: "A table for two, please",
      },
      {
        pl: "Co Pani/Pan poleca?",
        de: "What do you recommend?",
      },
      {
        pl: "Na przystawkę chciałbym/chciałabym sałatkę",
        de: "For starter I'd like a salad",
      },
      {
        pl: "To nie jest to co zamówiłem",
        de: "This is not what I ordered",
      },
      {
        pl: "Co mogę dla Pana/Pani zrobić?",
        de: "What can I do for you?",
      },
      {
        pl: "Czy mogę przyjąć zamówienie?",
        de: "Can I take your order?",
      },
      {
        pl: "Smacznego!",
        de: "Enjoy your meal!",
      },
      {
        pl: "Proszę czękac na wskazanie stolika",
        de: "Please wait to be seated",
      },
      {
        pl: "Chciałabym kurczaka z frytkami",
        de: "I'd like chicken and chips",
      },
    ],
  },
];

export { ZDANIA39 };
